const createPoliciesSlice = (set, get) => ({
  policiesData: {
    policies: {
      live: [],
      draft: [],
      current: [],
      local: []
    },
    selectedPolicy: {
      live: null,
      draft: null,
      current: null,
      local: null
    }
  },
  policySnackbar: {
    policyType: null,
    isCreated: null,
    severity: "success"
  },
  setPolicySnackbar: (policyType, isCreated, severity = "success") => {
    set({
      policySnackbar: {
        policyType,
        isCreated,
        severity
      }
    });
  },
  clearPolicySnackbar: () => {
    set({
      policySnackbar: {
        policyType: null,
        isCreated: null,
        severity: "success"
      }
    });
  },
  setSelectedPolicy: (value) => {
    const { policiesData, checkPolicyConfigChanged } = get();
    set({
      policiesData: {
        ...policiesData,
        selectedPolicy: {
          ...policiesData.selectedPolicy,
          local: value
        }
      }
    });
    checkPolicyConfigChanged(value);
  },
  policiesConfigChanged: false,
  setPoliciesConfigChanged: value => set({ policiesConfigChanged: value }),
  policyConfigChanged: false,
  setPolicyConfigChanged: value => set({ policyConfigChanged: value }),
  updateLocalPolicies: (policies) => {
    const { policiesData } = get();
    set({
      policiesData: {
        ...policiesData,
        policies: {
          ...policiesData.policies,
          local: policies
        }
      }
    });

    if (JSON.stringify(policies) !== JSON.stringify(policiesData?.policies?.current)) {
      set({ policiesConfigChanged: true });
    } else {
      set({ policiesConfigChanged: false });
    }
  },
  checkPolicyConfigChanged: (updatedPolicy) => {
    const { policiesData } = get();
    const currentPolicy = policiesData?.policies?.current?.find(p => p.metadata?.policyId === updatedPolicy?.metadata?.policyId);

    if (!currentPolicy) {
      const isNewPolicyEmpty = !updatedPolicy?.policyName && (!updatedPolicy?.scenarios || updatedPolicy?.scenarios?.length === 0);
      set({ policyConfigChanged: !isNewPolicyEmpty });
    } else if (JSON.stringify(policiesData?.selectedPolicy?.local) !== JSON.stringify(currentPolicy)) {
      set({ policyConfigChanged: true });
    } else {
      set({ policyConfigChanged: false });
    }
  }
});

export default createPoliciesSlice;
